// extracted by mini-css-extract-plugin
module.exports = {"root":"first_root__11dH1","check":"first_check__IVWai"};